export default {
  inDevelopment: {
    summary: 'Harmonogram produkcji jest w trakcie tworzenia',
    details: 'Tutaj zaplanujesz na podstawie zleceń, które wsady i kiedy zostaną uruchomione w poszczególnych piecach.',
  },
};
